<div class="datagrid-wrapper">
  <div class="page-header">
    <div class="header-title">
      <h3>Programmplan {{ selectedDate | date: 'fullDate' }}</h3>

      <!-- Filterleiste für Sender: Tab-artige Toggles pro Kanalspalte -->
      <div class="channel-filter-bar">
        <button
          *ngFor="let channel of availableChannels"
          type="button"
          class="channel-tab"
          [class.selected]="selectedChannels.includes(channel)"
          (click)="toggleChannel(channel)"
          [title]="selectedChannels.includes(channel) ? channel + ' ausblenden' : channel + ' einblenden'"
        >
          <img [src]="getIconFilename({ channel: channel })" [alt]="channel" />
        </button>

        <!-- LIVE Filter -->
        <button class="type-filter-btn" [class.selected]="showLive" (click)="toggleLive()">LIVE</button>

        <!-- VOD Filter -->
        <button class="type-filter-btn" [class.selected]="showVOD" (click)="toggleVOD()">VOD</button>

        <!-- Alle Kanäle ein-/ausblenden -->
        <button class="btn btn-outline btn-sm" (click)="toggleAllChannels()">
          <cds-icon [attr.shape]="allChannelsSelected ? 'minus-circle' : 'plus-circle'" class="is-solid"></cds-icon>
          {{ allChannelsSelected ? 'Alle ausblenden' : 'Alle aktivieren' }}
        </button>
      </div>

      <!-- Voxtral controls row -->
      <div class="voxtral-controls-bar">
        <div class="webrtc-player">
          <span class="webrtc-state-dot"
                [class.state-connected]="webrtcState === 'connected'"
                [class.state-connecting]="webrtcState === 'connecting'"
                [class.state-error]="webrtcState === 'error'"
                [title]="webrtcState"
                *ngIf="webrtcState !== 'disconnected'"></span>
          <select [(ngModel)]="selectedWebrtcChannel" [disabled]="isWebrtcPlaying">
            <option value="" disabled>Sender wählen</option>
            <option *ngFor="let ch of webrtcChannels" [value]="ch.sessionId">{{ ch.name }}</option>
          </select>
          <button class="btn btn-icon btn-sm"
                  [disabled]="!selectedWebrtcChannel || isWebrtcConnecting"
                  (click)="isWebrtcPlaying ? onWebrtcStop() : onWebrtcPlay()">
            <cds-icon [attr.shape]="isWebrtcPlaying ? 'stop' : 'play'"></cds-icon>
          </button>
        </div>
        <audio #webrtcAudio style="display:none"></audio>
        <div class="voxtral-schedule-launcher">
          <select [(ngModel)]="voxtralScheduleChannel"
                  title="Sender für die Sendungsplanung wählen">
            <option value="" disabled>Sender wählen</option>
            <option *ngFor="let ch of availableChannels" [value]="ch">{{ ch }}</option>
          </select>
          <button class="btn btn-outline btn-sm"
                  [disabled]="!voxtralScheduleChannel"
                  (click)="openVoxtralScheduleDialog()"
                  title="Sendungen für Voxtral-Transkription planen">
            Geplante Sendungen
          </button>
        </div>
        <ng-container *hasPermission="'manage-broadcasts'">
          <button class="btn btn-warning-outline btn-sm"
                  [disabled]="voxtralResetAllInProgress"
                  (click)="resetAllVoxtral()"
                  title="Alle Voxtral-Sessions für den ausgewählten Tag zurücksetzen">
            <clr-spinner *ngIf="voxtralResetAllInProgress" clrSmall clrInline></clr-spinner>
            Voxtral Reset All
          </button>
        </ng-container>
      </div>
    </div>

    <div class="header-actions">
      <clr-date-container>
        <label>Datum wählen</label>
        <input type="date" clrDate [(ngModel)]="selectedDate" (ngModelChange)="onDateChange($event)"
          placeholder="Datum wählen" />
      </clr-date-container>
    </div>
  </div>

  <!-- Ladeindikator -->
  <div class="loading-overlay" *ngIf="isLoading">
    <div class="loading-content">
      <cds-progress-circle size="xl" status="info"></cds-progress-circle>
      <p>Daten werden geladen …</p>
    </div>
  </div>

  <!-- Keine Einträge vorhanden -->
  <div class="no-data-message" *ngIf="!isLoading && visibleBroadcastsCount === 0">
    <cds-icon shape="info-circle" status="info" class="info-icon"></cds-icon>
    <p class="no-data-text">Für den gewählten Tag wurden keine Sendungen gefunden.</p>
  </div>

  <!-- Kalenderanzeige: eine Spalte pro Kanal, Logo im Spaltenkopf -->
  <div class="calendar-scroll" *ngIf="!isLoading && visibleBroadcastsCount > 0">
    <div class="header-row">
      <div class="corner-cell"></div>
      <div class="column-header" *ngFor="let col of columns; trackBy: trackByChannel">
        <img [src]="getIconFilename({ channel: col.channel })" [alt]="col.channel" [title]="col.channel" />
      </div>
    </div>

    <div class="body-row">
      <div class="time-column">
        <div *ngFor="let hour of hours" class="hour-label">{{ hour }}:00</div>
      </div>

      <div class="channel-lane" *ngFor="let col of columns; trackBy: trackByChannel">
        <div
          class="program-block"
          *ngFor="let broadcast of col.broadcasts; trackBy: trackByKey"
          [style.top.px]="broadcast.topPx"
          [style.height.px]="broadcast.heightPx"
          [ngClass]="{ 'initializing-broadcast': broadcast.transcribeLiveServiceIP==='blocked', 'live-broadcast': broadcast.transcribeLiveServiceIP, 'recorded-broadcast': !broadcast.transcribeLiveServiceIP }"
          (click)="showDetails(broadcast)"
          (mouseenter)="onBroadcastMouseEnter(broadcast, $event)"
          (mouseleave)="onBroadcastMouseLeave()"
        >
          <span class="program-line" [style.-webkit-line-clamp]="broadcast.lineClamp">
            <img *ngIf="broadcast.instanceInitializing" src="assets/anim-orange-rotate.svg" class="rotating-icon" alt="LIVE-Container initializing">
            <img *ngIf="isRecording(broadcast)" src="assets/anim-green-rotate.svg" class="rotating-icon" alt="LIVE-Container initializing">
            <cds-icon *ngIf="broadcast.editorialNoteKey"
                      [ngClass]="{ 'generated-editorial-notes': !broadcast.editorialNoteEditors, 'edited-editorial-notes': broadcast.editorialNoteEditors }"
                      shape="note"></cds-icon>
            <span *ngIf="broadcast.kiut" class="kiut-badge">KIUT</span>
            <span *ngIf="broadcast.live" class="live-badge">LIVE</span>
            <span *ngIf="broadcast.isPcmsDownloaded && !broadcast.isPretranscribed"
                  class="pcms-badge pcms-downloaded"
                  [title]="getPcmsTooltip(broadcast)">PCMS</span>
            <span *ngIf="broadcast.isPretranscribed"
                  class="pcms-badge pcms-pretranscribed"
                  [title]="getPcmsTooltip(broadcast)">PCMS</span>
            {{ broadcast.startsAt | date: 'HH:mm' }} {{ broadcast.title
            }}<span class="program-subtitle" *ngIf="broadcast.subtitle"> &ndash; {{ broadcast.subtitle }}</span>
          </span>
          <!-- Voxtral state indicator -->
          <span *ngIf="broadcast.voxtralMini4bRealtimeEc2IP === 'blocked'" class="voxtral-indicator voxtral-ind-starting" title="Voxtral EC2 startet">V</span>
          <span *ngIf="broadcast.voxtralMini4bRealtimeEc2IP && broadcast.voxtralMini4bRealtimeEc2IP !== 'blocked' && !broadcast.voxtralMini4bRealtimeSessionId && !broadcast.voxtralMini4bRealtimeSessionStoppedAt" class="voxtral-indicator voxtral-ind-session-starting" title="Voxtral Session wird erstellt">V</span>
          <a *ngIf="broadcast.voxtralMini4bRealtimeEc2IP && broadcast.voxtralMini4bRealtimeEc2IP !== 'blocked' && broadcast.voxtralMini4bRealtimeSessionId"
             class="voxtral-indicator voxtral-ind-running"
             [href]="'http://' + broadcast.voxtralMini4bRealtimeEc2IP"
             target="_blank"
             rel="noopener"
             [title]="'Voxtral Transkription aktiv — http://' + broadcast.voxtralMini4bRealtimeEc2IP"
             (click)="$event.stopPropagation()">V</a>
          <span *ngIf="!broadcast.voxtralMini4bRealtimeEc2IP && broadcast.voxtralMini4bRealtimeSessionStoppedAt && !broadcast.voxtralMini4bRealtimeEc2StoppedAt" class="voxtral-indicator voxtral-ind-session-stopped" title="Voxtral Session beendet">V</span>
          <span *ngIf="!broadcast.voxtralMini4bRealtimeEc2IP && broadcast.voxtralMini4bRealtimeEc2StoppedAt" class="voxtral-indicator voxtral-ind-ec2-stopped" title="Voxtral beendet">V</span>
          <span *ngIf="broadcast.voxtralMini4bRealtimeScheduled && !broadcast.voxtralMini4bRealtimeEc2IP && !broadcast.voxtralMini4bRealtimeEc2StartedAt && !broadcast.voxtralMini4bRealtimeSessionStartedAt && !broadcast.voxtralMini4bRealtimeEc2StoppedAt && !broadcast.voxtralMini4bRealtimeSessionStoppedAt" class="voxtral-indicator voxtral-ind-scheduled" title="Voxtral geplant">V</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Details Panel -->
  <app-overlay-panel *ngIf="detailsVisible" mode="center" size="xl"
                     ariaLabel="Sendungsdetails" (closed)="closeDetails()">
    <span overlay-title>
      <span class="op-title-main">{{ detailsBroadcast?.title }}</span>
      <span class="op-title-sub" *ngIf="detailsBroadcast?.subtitle">{{ detailsBroadcast?.subtitle }}</span>
    </span>
    <app-details [broadcast]="detailsBroadcast"></app-details>
  </app-overlay-panel>

  <!-- Voxtral Schedule Dialog -->
  <app-voxtral-schedule-dialog
    *ngIf="voxtralScheduleDialogVisible"
    [date]="selectedDate"
    [channel]="voxtralScheduleChannel"
    [broadcasts]="broadcasts"
    (closed)="closeVoxtralScheduleDialog()">
  </app-voxtral-schedule-dialog>
</div>
